import { createContext, useContext, useEffect, useState } from 'react'
import { superAdminLoginApi, superAdminLogoutApi } from '../api/api'

export const SuperAdminAuthContext = createContext(null)

export const useSuperAdminAuth = () => {
  const context = useContext(SuperAdminAuthContext);
  if (!context) {
    throw new Error('useSuperAdminAuth must be used within SuperAdminAuthProvider');
  }
  return context;
}

export default function SuperAdminAuthProvider({ children }) {
  const [superAdmin, setSuperAdmin] = useState(() => {
    const stored = localStorage.getItem('superAdmin')
    return stored ? JSON.parse(stored) : null
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('superAdminToken')
    if (!token) {
      setLoading(false)
      return
    }
    if (superAdmin) {
      setLoading(false)
      return
    }
    // For now, just check if token exists
    setLoading(false)
  }, [])

  const login = async (username, password) => {
    try {
      const res = await superAdminLoginApi({ username, password })
      const payload = res?.data?.data || res?.data || {}
      const { authToken, ...adminPayload } = payload
      if (authToken) {
        localStorage.setItem('superAdminToken', authToken)
        localStorage.setItem('superAdmin', JSON.stringify(adminPayload))
        setSuperAdmin(adminPayload)
      }
      return res
    } catch (err) {
      throw err
    }
  }

  const logout = async () => {
    try {
      await superAdminLogoutApi()
    } catch (err) {
      console.error('Logout error:', err)
    } finally {
      localStorage.removeItem('superAdminToken')
      localStorage.removeItem('superAdmin')
      setSuperAdmin(null)
    }
  }

  const isAuthenticated = !!localStorage.getItem('superAdminToken')

  return (
    <SuperAdminAuthContext.Provider value={{ superAdmin, login, logout, isAuthenticated, loading }}>
      {children}
    </SuperAdminAuthContext.Provider>
  )
}

